import Skills from "./SkillsList";
export default Skills;